import React from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";
import UserInput from "../UI/ReactUserInput";
import UserInputTextarea from "../UI/ReactUserInputTextarea";

export default class ChildProgressReviewAttendance extends MultiPageForm
{
	constructor(props) 
	{
		super(props);

		if ( this.props.attendanceData != null )
		{
			this.state.attendanceData = this.props.attendanceData ;

			if ( props.attendanceData.pcent == 100 )
			{
				this.state.attReasonRequired = false ;
				this.state.attPcent = props.attendanceData.pcent ;
			}
			else
			{
				this.state.attReasonRequired = true ;
				this.state.attPcent = '' ;
			}
		}
		else
		{
			this.state.attReasonRequired = true ;
			this.state.attPcent = '' ;
		}


		if ( this.props.punctualityData != null )
		{
			this.state.punctualityData = this.props.punctualityData ;

			if ( props.punctualityData.pcent == 100 )
			{
				this.state.puncReasonRequired = false ;
				this.state.puncPcent = props.punctualityData.pcent ;
			}
			else
			{
				this.state.puncReasonRequired = true ;
				this.state.puncPcent = '' ;
			}
		}
		else
		{
			this.state.puncReasonRequired = true ;
			this.state.puncPcent = '' ;
		}

		let t1 = 0 ;
		let t2 = 0 ;

		if ( this.props.attendanceData.unauthorised_absences != null ) {
			t1 = this.props.attendanceData.unauthorised_absences;
		}

		if ( this.props.attendanceData.authorised_absences != null )
		{
			t2 = this.props.attendanceData.authorised_absences ;
		}

		this.state.lostSessionTotal = +t1 + +t2 ;

		this.keyCount = 1 ;

		this.recalcPercentages = this.recalcPercentages.bind(this) ;

	}

	updateReviewRecords ( reviewData) 
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var data = { review_data: reviewData } ; 
		
    	$.ajax({
  		  type: 'PUT',
  		  url: root + '/children/' + reviewData.child_id + '/review',
  		  data: data,
  		  async: false,
  		  beforeSend:function(){
  		    // this is where we append a loading image
  		  },
  		  success:(data)=>{
  			  
  				// Call the whole thing off		
  				if ( checkError(data))
  				{
  					this.setDirty ( false ) ;
  				}
  		  },
  		  error:function(jqXHR, textStatus, error){
				handleAjaxError(jqXHR, textStatus, error) ;
  		  }
  		});
	}

	getFormData()
	{
		var punc = {} ; 
		var att = {} ; 

		att.days = this.refs.InputAttendanceDays.getValue() ;
		att.out_of_days = this.refs.InputAttendanceTotal.getValue() ;
		// att.pcent = this.refs.InputAttendancePercentage.getValue() ;
		att.reason = this.refs.InputAttendanceReasons.getValue() ;
		att.unauthorised_absences = this.refs.InputUnauthorisedAbsences.getValue() ;
		att.authorised_absences = this.refs.InputAuthorisedAbsences.getValue() ;
		punc.days = this.refs.InputPunctualityDays.getValue() ;
		punc.out_of_days = this.refs.InputPunctualityTotal.getValue() ;
		punc.pcent = this.refs.InputPunctualityPercentage.getValue() ;
		punc.reason = this.refs.InputPunctualityReasons.getValue() ;
		punc.action = this.refs.InputPunctualityAction.getValue() ;

		var data = {} ;

		data.attendance = att ;
		data.punctuality = punc ;

		return data ;
	}

	doSave()
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var attendanceData = this.getFormData() ;

			var reviewData = {} ;

			reviewData.progress_review_id = this.props.review_data.progress_review_id ;
			reviewData.child_id = this.props.child_id ;
			reviewData.attendance_data = attendanceData ;

			this.updateReviewRecords (reviewData) ;
		}
	}

	onLeave()
	{
		if ( this.props.autoSave == true )
		{
			if (this.formIsValid())
			{
				this.autoSave() ;		
			}
		}
	}	
	
	autoSave()
	{
		if ( this.isDirty() )
		{
			this.doSave() ;			
		}
	}

	isDirty()
	{
		var result = false ;

		if ( this.refs.InputAttendanceDays.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputUnauthorisedAbsences.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputAuthorisedAbsences.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputAttendanceTotal.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputAttendanceReasons.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputPunctualityDays.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputPunctualityTotal.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputPunctualityReasons.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputPunctualityAction.isDirty() )
		{
			result = true ;
		}

		if ( this.refs.InputAttendanceTotalSessionsLost.isDirty() )
		{
			result = true ;
		}

		return result ;
	}	
	
	setDirty( value )
	{
		this.refs.InputAttendanceDays.setDirty(value) ;
		this.refs.InputAttendanceTotal.setDirty(value) ;
		this.refs.InputAttendanceReasons.setDirty(value) ;
		this.refs.InputUnauthorisedAbsences.setDirty(value) ;
		this.refs.InputAuthorisedAbsences.setDirty(value) ;
		this.refs.InputPunctualityDays.setDirty(value) ;
		this.refs.InputPunctualityTotal.setDirty(value) ;
		this.refs.InputPunctualityReasons.setDirty(value) ;
		this.refs.InputPunctualityAction.setDirty(value) ;
		this.refs.InputAttendanceTotalSessionsLost.setDirty(value) ;

		if ( value == false )
		{
			if ( this.props.setDirty != null )
			{
                this.props.setDirty(value) ;
			}
		}
	}

	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.onSave != null )
			{
				// Just pass the click back to the creating form
				this.props.onSave() ;
			}	
		}
	}
	
	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}
	}


	getFormattedDate(date) 
	{
		  var year = date.getFullYear();
		  var month = (1 + date.getMonth()).toString();
		  month = month.length > 1 ? month : '0' + month;
		  var day = date.getDate().toString();
		  day = day.length > 1 ? day : '0' + day;
		  return day + '/' + month + '/' + year;
	}

	calcTotalDaysLost()
	{
		let calc = 0 ;

		if ( this.refs != null && this.refs.InputUnauthorisedAbsences != null )
		{
			let unauthorised_absences = this.refs.InputUnauthorisedAbsences.getValue() ;

			if ( unauthorised_absences == null || unauthorised_absences == '')
			{
				unauthorised_absences = 0 ;
			}

			let authorised_absences = this.refs.InputAuthorisedAbsences.getValue() ;

			if ( authorised_absences == null || authorised_absences == '')
			{
				authorised_absences = 0 ;
			}

			calc = +unauthorised_absences + +authorised_absences ;
		}
		else
		{
			calc = +this.props.attendanceData.unauthorised_absences + +this.props.attendanceData.authorised_absences ;
		}

		return calc ;
	}

	recalcPercentages()
	{
		let lost = this.calcTotalDaysLost() ;

		var pdays = this.refs.InputPunctualityDays.getValue() ;
		var poutof = this.refs.InputPunctualityTotal.getValue() ;
		var newatt = this.state.punctualityData ;

		if ( pdays != '' && poutof != '' )
		{
			if ( Number.isInteger(+pdays) && Number.isInteger(+poutof))
			{
				if ( +poutof > 0 )
				{
					var pcent =  Math.round((( pdays / poutof ).toPrecision(3))*100);

					if ( pcent == 100 )
					{
						var puncReasonRequired = false ;
					}
					else
					{
						var puncReasonRequired = true ;
					}

					newatt.pcent = pcent ;

					this.setState ({punctualityData: newatt, puncReasonRequired : puncReasonRequired, lostSessionTotal: lost}) ;
				}
			}
		}
		else
		{
			this.setState ({lostSessionTotal: lost}) ;
		}
	}

	rowAttendanceDays()
	{
		var lineList=[];
		
		var fieldType = '';
		
		if ( this.props.readonly == true || this.props.mode == 'view' )
		{
			fieldType = "readonly";
		}

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-3'},
					React.createElement ( UserInput, { 
		        	  validation: { required: true, maxlen: 3, isInteger: true}, 
					  name: 'InputAttendanceDays',
					  ref: 'InputAttendanceDays',
					  labelText: 'Actual Sessions Attended',
					  errorText: 'Valid number required',
					  value: this.state.attendanceData.attended_days,
					  tabIndex: 1,
					  readOnly: fieldType, 
					  displayErrors:this.state.displayErrors,
					  key: this.keyCount++,
					  autoComplete: 'off',
					  onBlur: this.recalcPercentages,
					  onDirty: this.onDirty
					  }))) ;
		
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-3'},
				React.createElement ( UserInput, { 
	        	  validation: { required: true, maxlen: 3, isInteger: true}, 
				  name: 'InputAttendanceTotal',
				  ref: 'InputAttendanceTotal',
				  labelText: 'Out of possible',
				  errorText: 'Valid number required',
				  value: this.state.attendanceData.out_of_days,
				  tabIndex: 2,
				  readOnly: fieldType, 
				  displayErrors:this.state.displayErrors,
				  onBlur: this.recalcPercentages,
				  onDirty: this.onDirty,
				  autoComplete: 'off',
				  key: this.keyCount++
				  }))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
			React.createElement ( UserInput, {
				validation: { required: true, maxlen: 3, isInteger: true},
				name: 'InputUnauthorisedAbsences',
				ref: 'InputUnauthorisedAbsences',
				labelText: 'Unauthorised absences',
				errorText: 'Valid number required',
				value: this.state.attendanceData.unauthorised_absences,
				autoComplete: 'off',
				tabIndex: 3,
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				key: this.keyCount++,
				onBlur: this.recalcPercentages,
				onDirty: this.onDirty
			}))) ;

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
			React.createElement ( UserInput, {
				validation: { required: true, maxlen: 3, isInteger: true},
				name: 'InputAuthorisedAbsences',
				ref: 'InputAuthorisedAbsences',
				labelText: 'Authorised absences',
				errorText: 'Valid number required',
				value: this.state.attendanceData.authorised_absences,
				autoComplete: 'off',
				tabIndex: 3,
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				onBlur: this.recalcPercentages,
				onDirty: this.onDirty,
				key: this.keyCount++
			}))) ;

		/*var pcent = 1 - ( this.state.attendanceData.days / this.state.attendanceData.out_of_days ) ;
		
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'}, 
				React.createElement ( UserInput, { 
	        	  validation: { required: false, maxlen: 3, isPercentage: true}, 
				  id: 'InputAttendancePercentage', 
				  name: 'InputAttendancePercentage',
				  ref: 'InputAttendancePercentage',
				  labelText: 'Percent', 
				  errorText: 'Valid number required',
				  value: this.state.attendanceData.pcent,
				  tabIndex: 3,
				  readOnly: fieldType, 
				  displayErrors:this.state.displayErrors,
				  onDirty: this.onDirty,
				  key: this.keyCount++
				  }))) ;

	*/

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'},
			React.createElement ( UserInput, {
				validation: { required: true, maxlen: 3, isInteger: true},
				id: 'InputAttendanceTotalSessionsLost',
				name: 'InputAttendanceTotalSessionsLost',
				ref: 'InputAttendanceTotalSessionsLost',
				labelText: 'Total sessions lost',
				errorText: 'Valid number required',
				value: this.state.lostSessionTotal,
				autoComplete: 'off',
				tabIndex: 5,
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				onBlur: this.recalcPercentages,
				onDirty: this.onDirty,
				key: this.keyCount++
			}))) ;
	
		/*lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2},
				React.createElement ( UserInputTextarea, { 
	        	  validation: { required: this.state.attReasonRequired, maxlen: 255}, 
				  id: 'InputAttendanceAction', 
				  name: 'InputAttendanceAction',
				  ref: 'InputAttendanceAction',
				  label: 'Action taken', 
				  errorText: 'This must be a valid input',
				  value: this.state.attendanceData.action,
				  tabIndex: 5,
				  readOnly: fieldType,
				  onDirty: this.onDirty,
				  displayErrors:this.state.displayErrors,
				  key: this.keyCount++
				  }))) ; */
	
		return lineList ;		
	}

	rowAttendanceComments()
	{
		var lineList=[];

		var fieldType = '';

		if ( this.props.readonly == true || this.props.mode == 'view' )
		{
			fieldType = "readonly";
		}

		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-12'},
			React.createElement ( UserInputTextarea, {
				validation: { required: false, maxlen: 255},
				id: 'InputAttendanceReasons',
				name: 'InputAttendanceReasons',
				ref: 'InputAttendanceReasons',
				label: 'Comments',
				errorText: 'This must be a valid input',
				value: this.state.attendanceData.reason,
				tabIndex: 6,
				readOnly: fieldType,
				displayErrors:this.state.displayErrors,
				onDirty: this.onDirty,
				key: this.keyCount++
			}))) ;

		return lineList ;
	}


	row2Content()
	{
		var lineList=[];
		
		var fieldType = '';
		
		if ( this.props.readonly == true || this.props.mode == 'view' )
		{
			fieldType = "readonly";
		}
		
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'}, 
					React.createElement ( UserInput, { 
		        	  validation: { required: true, maxlen: 3, isInteger: true}, 
					  id: 'InputPunctualityDays', 
					  name: 'InputPunctualityDays',
					  ref: 'InputPunctualityDays',
					  labelText: 'Days punctual', 
					  errorText: 'Valid number required',
					  value: this.state.punctualityData.days,
					  tabIndex: 10,
					  readOnly: fieldType, 
					  displayErrors:this.state.displayErrors,
					  onBlur: this.recalcPercentages,
					  onDirty: this.onDirty,
					  key: this.keyCount++
					  }))) ;
		
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'}, 
				React.createElement ( UserInput, { 
	        	  validation: { required: true, maxlen: 3, isInteger: true}, 
				  id: 'InputPunctualityTotal', 
				  name: 'InputPunctualityTotal',
				  ref: 'InputPunctualityTotal',
				  labelText: 'Out of (total)', 
				  errorText: 'Valid number required',
				  value: this.state.punctualityData.out_of_days,
				  tabIndex: 11,
				  readOnly: fieldType, 
				  onBlur: this.recalcPercentages,
  				  onDirty: this.onDirty,
				  displayErrors:this.state.displayErrors,
				  key: this.keyCount++
				  }))) ;
	
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-2'}, 
				React.createElement ( UserInput, { 
	        	  validation: { required: false, maxlen: 3, isPercentage: true}, 
				  id: 'InputPunctualityPercentage', 
				  name: 'InputPunctualityPercentage',
				  ref: 'InputPunctualityPercentage',
				  labelText: 'Percent', 
				  errorText: 'Valid number required',
				  value: this.state.punctualityData.pcent,
				  tabIndex: 12,
				  readOnly: fieldType,
				  onDirty: this.onDirty,
				  displayErrors:this.state.displayErrors,
				  key: this.keyCount++
				  }))) ;
		
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-3'}, 
				React.createElement ( UserInputTextarea, { 
	        	  validation: { required: this.state.puncReasonRequired, maxlen: 255 }, 
				  id: 'InputPunctualityReasons', 
				  name: 'InputPunctualityReasons',
				  ref: 'InputPunctualityReasons',
				  label: 'Reasons', 
				  errorText: 'This must be a valid input',
				  value: this.state.punctualityData.reason,
				  tabIndex: 13,
				  readOnly: fieldType,
  				  onDirty: this.onDirty,
				  displayErrors:this.state.displayErrors,
				  key: this.keyCount++
				  }))) ;
	
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-3'}, 
				React.createElement ( UserInputTextarea, { 
	        	  validation: { required: this.state.puncReasonRequired, maxlen: 255 }, 
				  id: 'InputPunctualityAction', 
				  name: 'InputPunctualityAction',
				  ref: 'InputPunctualityAction',
				  label: 'Action taken', 
				  errorText: 'This must be a valid input',
				  value: this.state.punctualityData.action,
				  tabIndex: 14,
				  readOnly: fieldType,
				  onDirty: this.onDirty,
				  displayErrors:this.state.displayErrors,
				  key: this.keyCount++
				  }))) ;
	
		return lineList ;		
	}

	
	formRow1 ()
    {
    	let lineList = [] ;

    	lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'row attendance-panel'} , this.rowAttendanceDays())) ;
		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , this.rowAttendanceComments()));

        return React.createElement ( 'div', { key: this.keyCount++, className: ''} , lineList) ;
    }

	formRow2 ()
    {
        return React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , this.row2Content()) ;
    }
	
	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	buttonRow ()
    {
        var lineList=[];
        
        if ( this.props.mode == 'view')
        {
			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

			lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3', style: { paddingRight: '0px'}},
					 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '0px' }, onClick: this.onCancel.bind(this) }, 'Close')))

        }
        else
        {
			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

			lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3', style: { paddingRight: '0px'}},
					 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' } , onClick: this.onSave.bind(this) }, 'Save'),
					 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
        	
        }
        
        return React.createElement('div', { className: 'row', key: this.keyCount++ }, lineList );
    }

    p1()
	{
		var lineList=[];

		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-heading' }, 'Attendance'));

		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-body' }, this.formRow1() ));

		return React.createElement ( 'div', { key: this.keyCount++, className: 'panel panel-default panel-subject' }, lineList) ;
	}

	p2()
	{
		var lineList=[];

		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-heading' }, 'Punctuality'));

		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-body' }, this.formRow2() ));

		return React.createElement ( 'div', { key: this.keyCount++, className: 'panel panel-default panel-subject' }, lineList) ;
	}


	formRows ()
	{
		var lineList=[];

		lineList.push ( this.p1());
		lineList.push ( this.p2());

		lineList.push(this.navFormRow()) ;

		return lineList ;
	}
	
	render() 
    {
		this.keyCount=0;
        return React.createElement('div', { key: this.keyCount++, className: 'panel'}, this.formRows());
  }
};